import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, of } from 'rxjs';
import { CopyService } from '../../../services/copy.service';
import { SnackbarService } from '../../../services/snackbar.service';

export interface EditCopyDialogData {
  copyKey: string;
}

export interface EditCopyDialogResult {
  success: boolean;
}

@Component({
  selector: 'app-edit-copy-dialog',
  templateUrl: './edit-copy-dialog.component.html',
  styleUrls: ['./edit-copy-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditCopyDialogComponent implements OnInit {
  loading = true;
  copyData: { copyKey: string; placeHolderInHungarian: string; placeHolderInEnglish: string } | null = null;
  editForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EditCopyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCopyDialogData,
    private fb: FormBuilder,
    private copyService: CopyService,
    private snackbarService: SnackbarService,
    private cdr: ChangeDetectorRef,
  ) {
    this.editForm = this.fb.group({
      newHungarian: ['', Validators.required],
      newEnglish: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadCopyData();
  }

  private loadCopyData(): void {
    this.loading = true;
    this.cdr.markForCheck();

    this.copyService
      .getCopyByKey$(this.data.copyKey)
      .pipe(
        catchError(() => {
          this.snackbarService.error('A copy elem adatainak lekérése során hiba lépett fel!');
          setTimeout(() => this.dialogRef.close({ success: false }), 1500);
          return of();
        }),
      )
      .subscribe((copy) => {
        if (copy) {
          this.copyData = copy;
          this.loading = false;
          this.cdr.markForCheck();
        }
      });
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.snackbarService.success('Szöveg vágólapra másolva');
    });
  }

  onCancel(): void {
    this.dialogRef.close({ success: false });
  }

  onSave(): void {
    if (!this.copyData || this.editForm.invalid) {
      return;
    }

    const { newHungarian, newEnglish } = this.editForm.value;

    this.copyService
      .updateCopyByKey$(this.data.copyKey, {
        copyKey: this.data.copyKey,
        placeHolderInHungarian: newHungarian,
        placeHolderInEnglish: newEnglish,
      })
      .pipe(
        catchError(() => {
          this.snackbarService.error('Sikertelen módosítás. Kérjük, próbáld újra!');
          return of();
        }),
      )
      .subscribe(() => {
        this.snackbarService.success('Sikeres módosítás');
        this.dialogRef.close({ success: true });
      });
  }
}
